import { render, staticRenderFns } from "./OnboardingWizardLink.vue?vue&type=template&id=037b6f14&"
import script from "./OnboardingWizardLink.vue?vue&type=script&lang=js&"
export * from "./OnboardingWizardLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports